import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useCreate: useJurySessionsSignPvCreation } = getCRUDHooks({
  entityName: 'createJurySessionsSignPv',
  create: ({ jurySessionId }) =>
    clientApi.getOCClient().helpers.learningActivity.jurySessions.id(jurySessionId).signPv.create(),
});

// eslint-disable-next-line import/prefer-default-export
export { useJurySessionsSignPvCreation };
